export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" fill-rule="evenodd" d="M20 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16ZM3.5 18a.5.5 0 0 0 .5.5h10.5v-3.75h-11V18Zm12.5.5h4a.5.5 0 0 0 .5-.5V9.5H16v9ZM3.5 13.25h11V9.5h-11v3.75Z" clip-rule="evenodd"/>
</svg>
`;
